import aeva from './ai-startup-website-template';
import lithos from './architecture-website-template';
import dentry from './dental-clinic-website-template';
import dentra from './dentra-dental-clinic-framer-template';
import fiidbakk from './fiidbakk';
import clause from './law-firm-website-template';
import mld from './mold-inspection-website-template';
import deckker from './saas-website-template';
import moro from './venture-capital-website-template';

export const templateTranslationsBySlug = {
  'ai-startup-website-template': aeva,
  'architecture-website-template': lithos,
  'dental-clinic-website-template': dentry,
  'dentra-dental-clinic-framer-template': dentra,
  fiidbakk,
  'law-firm-website-template': clause,
  'mold-inspection-website-template': mld,
  'saas-website-template': deckker,
  'venture-capital-website-template': moro,
};
